module.exports = __webpack_public_path__ + "img/back.7f0ad239.svg";